import {TranslationObject} from '@colonist/i18n'
import {LobbyImage} from '@colonist/types'
import {createDivIn, createSpanIn, createImgIn, setElementOnClick} from '../../../../shared/scripts/ui_utils/DomUtils'
import {getLobbyImagePath} from '../../../../shared/scripts/ui_utils/Utils'

export class UIMRoomEditableCard {
    private readonly cardContainer: HTMLDivElement
    private readonly titleContainer: HTMLSpanElement
    private readonly imageContainer: HTMLImageElement
    private readonly pencilImg: HTMLImageElement
    private isViewOnly: boolean

    constructor(container: HTMLDivElement, title: TranslationObject, image: LobbyImage, onClick: () => void, isViewOnly: boolean = false) {
        this.isViewOnly = isViewOnly

        this.cardContainer = createDivIn(container, 'm-room-settings-card-container-min m-room-settings-card-container-min-selected')

        const cardHeaderContainer = createDivIn(this.cardContainer, 'm-room-settings-card-header-container')
        const titleContainer = createDivIn(cardHeaderContainer, 'm-room-settings-card-title')

        this.titleContainer = createSpanIn(titleContainer, 'm-room-settings-card-title', title)
        this.imageContainer = createImgIn(cardHeaderContainer, image, 'm-room-settings-card-icon')
        this.pencilImg = createImgIn(cardHeaderContainer, LobbyImage.Pencil)

        if(isViewOnly) {
            this.cardContainer.classList.remove('m-room-settings-card-container-min-selected')
            this.pencilImg.classList.add('hidden')
        }

        setElementOnClick(this.cardContainer, () => {
            if(this.isViewOnly) return
            onClick()
        })
    }

    update(title: string, image: LobbyImage, isViewOnly: boolean = false) {
        this.isViewOnly = isViewOnly
        this.titleContainer.innerText = title
        this.imageContainer.src = getLobbyImagePath(image)
        if(isViewOnly) {
            this.cardContainer.classList.remove('m-room-settings-card-container-min-selected')
            this.pencilImg.classList.add('hidden')
        } else {
            this.cardContainer.classList.add('m-room-settings-card-container-min-selected')
            this.pencilImg.classList.remove('hidden')
        }
    }

    hide() {
        this.cardContainer.hidden = true
    }

    show() {
        this.cardContainer.hidden = false
    }
}
